import React from 'react';
import { Box, IconButton, Link } from '@mui/material';
import { Message } from './types';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ReactMarkdown from 'react-markdown';

interface ChatMessageProps {
  message: Message;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(message.content);
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: message.role === 'user' ? 'flex-end' : 'flex-start', minWidth: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, maxWidth: '80%', minWidth: 0 }}>
        <Box
          sx={{
            px: 2,
            py: 1.5,
            borderRadius: '8px',
            bgcolor: message.role === 'user' ? 'black' : '#f3f4f6',
            color: message.role === 'user' ? 'white' : '#374151',
            fontSize: '14px',
            lineHeight: 1.5,
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
            overflow: 'hidden',
            minWidth: 0,
            '& *': { maxWidth: '100%', wordBreak: 'break-word', overflowWrap: 'anywhere' },
            '& p': { margin: '0.5em 0' },
            '& ul, & ol': { paddingLeft: '1.5em', margin: '0.5em 0' },
            '& code': { bgcolor: message.role === 'user' ? '#333' : '#e5e7eb', px: 0.5, borderRadius: '3px', wordBreak: 'break-all', display: 'inline-block', maxWidth: '100%' },
            '& pre': { bgcolor: message.role === 'user' ? '#333' : '#e5e7eb', p: 1, borderRadius: '4px', overflowX: 'auto', maxWidth: '100%' },
            '& pre code': { display: 'block', whiteSpace: 'pre-wrap', wordBreak: 'break-all' },
          }}
        >
          {message.role === 'assistant' ? (
            <>
              <ReactMarkdown>{message.content}</ReactMarkdown>
              {message.sources && message.sources.length > 0 && (
                <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #d1d5db' }}>
                  <Box sx={{ fontWeight: 600, mb: 1, fontSize: '13px' }}>References:</Box>
                  {message.sources.map((source, idx) => (
                    <Box key={idx} sx={{ mb: 0.5 }}>
                      <Link
                        href={source.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ fontSize: '13px', color: '#2563eb', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                      >
                        {source.document_name}
                      </Link>
                    </Box>
                  ))}
                </Box>
              )}
            </>
          ) : (
            message.content
          )}
        </Box>
        {message.role === 'assistant' && (
          <IconButton onClick={handleCopy} sx={{ p: 0.5, color: '#9ca3af', '&:hover': { color: '#4b5563' } }}>
            <ContentCopyIcon sx={{ fontSize: 16 }} />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};
